const Environment = {
  production: window._env_.REACT_APP_PRODUCTION === "true",
  validate_email: window._env_.REACT_APP_VALIDATE_EMAIL === "true",
  api: window._env_.REACT_APP_API,
  statics: window._env_.REACT_APP_STATICS,
  ws: window._env_.REACT_APP_WS,
};

export default Environment;
